import { useSelector } from 'react-redux';
import { getOrder, getOrderAmount } from '../../selectors';

export const useOrder = () => ({
  order: useSelector(getOrder),
  amount: useSelector(getOrderAmount),
});
